"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../utils/index");

var _checkmark_icon_component = _interopRequireDefault(require("./checkmark_icon_component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$data = props.data,
      data = _props$data === void 0 ? {} : _props$data,
      multiple = props.multiple,
      titleable = props.titleable,
      _props$useCheckMark = props.useCheckMark,
      useCheckMark = _props$useCheckMark === void 0 ? false : _props$useCheckMark;

  var _getTheContentOfTheIt = (0, _index.getTheContentOfTheItemComponent)(_objectSpread({}, props, {
    disabled: data.disabled || false
  })),
      className = _getTheContentOfTheIt.className,
      labelDom = _getTheContentOfTheIt.labelDom,
      label = _getTheContentOfTheIt.label,
      onClick = _getTheContentOfTheIt.onClick;

  var title = '';

  if (titleable && (typeof label === 'string' || typeof label === 'number')) {
    title = label;
  }

  return _react["default"].createElement("li", {
    className: className,
    onClick: onClick,
    "data-index": props['data-index']
  }, multiple || useCheckMark ? _react["default"].createElement(_checkmark_icon_component["default"], null) : null, _react["default"].createElement("div", {
    className: "selection-name",
    title: title
  }, _react["default"].createElement("p", null, labelDom)));
};

exports["default"] = _default;